import gql from 'graphql-tag';

import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';

export const QUERY_PAGE = gql`
  query Page($key: String!) {
    pages(where: { key: $key }, limit: 1) {
      id
      name
      title_en
      title_de
      meta_title_en
      meta_title_de
      meta_description_en
      meta_description_de
      dynamic_content {
        ...dynamicZone
      }
    }
  }
  ${FRAGMENT_DYNAMIC_ZONES}
  ${FRAGMENT_HERO}
`;
